import React from 'react'
import PropTypes from 'prop-types'

import Tooltip from 'Pods/Shared/Tooltip'

function JobHeader({ status, price = null }) {
  return (
    <div className="job-description__header">
      {status === 'Exclusive offer' ? (
        <Tooltip
          tooltipClassName="tooltip--medium"
          className="job-description__header-tooltip"
          id="dashboard__jobs-exclusive"
          content="This is a private job offer from customer interested in exclusive cooperation with you. Do not
          forget to reply to your custom job offers!"
        >
          <div className="btn btn-sm job-description__status is-exclusive">{status}</div>
        </Tooltip>
      ) : (
        <div className="btn btn-sm job-description__status">{status}</div>
      )}
      {price
        && (
        <div className="job-description__header-info">
          {price.title}:
          <span className="job-description__offer">
            {price.value}
          </span>
        </div>
        )
      }
    </div>
  )
}

JobHeader.propTypes = {
  status: PropTypes.string.isRequired,
  price: PropTypes.shape({
    title: PropTypes.string,
    value: PropTypes.string,
  }),
}

export default JobHeader
